import React, { PureComponent } from 'react'
import { Grid } from '@material-ui/core'
import { connect } from 'react-redux'

import { deleteMembers, deleteVendors, deletePhysicians } from '../../../actions/company'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ResetSettings from '../../../components/ResetSettings'

class ResetCompanySettings extends PureComponent {
  deleteMembers = (password) => {
    return this.props.dispatch(deleteMembers(password))
  }

  deleteVendors = (password) => {
    return this.props.dispatch(deleteVendors(password))
  }

  deletePhysicians = (password) => {
    return this.props.dispatch(deletePhysicians(password))
  }

  render() {
    const resetData = [
      {
        title: 'Delete Members',
        info: 'Deleting your members will delete all of their information including any attached documents.',
        modalInfo: 'Do you want to delete all Members?',
        onConfirm: this.deleteMembers,
        confirmText: 'Delete',
        buttonTitle: 'Delete All Members',
      },
      {
        title: 'Delete Vendors',
        info: 'Deleting your vendors will erase all vendor information. Note, you must delete all products before deleting vendors.',
        modalInfo: 'Do you want to delete all Vendors?',
        onConfirm: this.deleteVendors,
        confirmText: 'Delete',
        buttonTitle: 'Delete All Vendors',
      },
      {
        title: 'Delete Physicians',
        info: 'Deleting your physicians will erase all physician information. Note, you must delete all members before deleting physicians.',
        modalInfo: 'Do you want to delete all Physicians?',
        onConfirm: this.deletePhysicians,
        confirmText: 'Delete',
        buttonTitle: 'Delete All Physicians',
      },
    ]

    return (
      <Grid container>
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          justify="center"
          alignItems="center"
          alignContent="center"
        >
          <p>WARNING!! Resetting your data will completely delete all data points.</p>
        </Grid>
        {resetData &&
          resetData.length &&
          resetData.map((data, index) => {
            return <ResetSettings {...data} key={index} />
          })}
      </Grid>
    )
  }
}
export default connect((state) => ({
  dispatch: state.dispatch,
}))(ContainerWithTitle(ResetCompanySettings, 'Reset Company Settings'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/ResetCompanySettings.js